import React from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, { Pagination, Navigation } from "swiper";

// styles
import styles from "./styles.module.scss";

// components
import Item from "./Item";

// mockup
import mockup from "src/utils/data";

SwiperCore.use([Pagination, Navigation]);

const RecentlyViewed = () => {
  return (
    <div className={`recently ${styles.viewed__wrapper}`}>
      {/* in progress */}
      <Swiper
        spaceBetween={16}
        slidesPerView="auto"
        slidesPerGroup={1}
        navigation={true}
        centeredSlides={false}
        breakpoints={{
          576: {
            spaceBetween: 10,
            slidesPerView: 3,
            slidesPerGroup: 3,
            centeredSlides: false,
          },
        }}
      >
        {mockup.recent_events.map((item) => (
          <SwiperSlide key={item.id}>
            <Item data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default RecentlyViewed;
